import { RecentCookLocationResponse } from "../../services/CookLiveLocationService";

export const dummyCookLocations: RecentCookLocationResponse[] = [
    {
        "cookId": 87273,
        "cookName": "Mr. Vijay  Kumar Verma",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0854056,
                28.5295339
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:03:17.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0854056,
                28.5295339
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:03:17.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 152572,
            "time": "06:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 443561,
            "houseCoordinates": {
                "lat": 28.50404189999996,
                "long": 77.06847610000001
            }
        }
    },
    {
        "cookId": 4854,
        "cookName": "Mr. Shivanand Mishra",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.052728,
                28.4094966
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:00:16.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 168279,
            "time": "05:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 452848,
            "houseCoordinates": {
                "lat": 28.4280239,
                "long": 77.042589
            }
        }
    },
    {
        "cookId": 5284,
        "cookName": "Mrs. Soni ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0490432,
                28.3954853
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:58:57.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 167158,
            "time": "04:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 21327,
            "houseCoordinates": {
                "lat": 28.412385316055516,
                "long": 77.08761680000006
            }
        }
    },
    {
        "cookId": 13326,
        "cookName": "Mr. Emlus Kerketta",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0949451,
                28.4298964
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:04:49.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0949446,
                28.4298617
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:00:49.000Z",
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 178248,
            "time": "01:30 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T08:14:47.000Z",
            "houseId": 482358,
            "houseCoordinates": {
                "lat": 28.429738006747808,
                "long": 77.0949571393749
            }
        },
        "nextVisit": {
            "id": 177341,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 467018,
            "houseCoordinates": {
                "lat": 28.3919387,
                "long": 77.0638751
            }
        }
    },
    {
        "cookId": 92263,
        "cookName": "Mrs. Babita Tamang  Limbu",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                76.9879,
                28.4080222
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:30.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                76.9688175,
                28.4108087
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:00:44.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 165054,
            "time": "05:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 185001,
            "houseCoordinates": {
                "lat": 28.40906171034653,
                "long": 77.04010566696525
            }
        }
    },
    {
        "cookId": 91838,
        "cookName": "Mr. Ramen Kumar Mandal",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0357568,
                28.4035514
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:25.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0357568,
                28.4035514
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:25.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 165444,
            "time": "05:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 115445,
            "houseCoordinates": {
                "lat": 28.39199969488927,
                "long": 77.06411296395108
            }
        }
    },
    {
        "cookId": 88903,
        "cookName": " Mr. Dilip     ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.1134812,
                28.4199885
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:09.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.1134851,
                28.4199907
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:04:06.000Z",
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 175165,
            "time": "09:30 AM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T04:35:46.000Z",
            "houseId": 481521,
            "houseCoordinates": {
                "lat": 28.444331361499287,
                "long": 77.10489559584443
            }
        },
        "nextVisit": {
            "id": 177107,
            "time": "03:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 136888,
            "houseCoordinates": {
                "lat": 28.413421600000017,
                "long": 77.11219179999996
            }
        }
    },
    {
        "cookId": 12806,
        "cookName": "Mr. Rohit  ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.06315500000001,
                28.429301666666667
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T07:31:28.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": null
    },
    {
        "cookId": 74472,
        "cookName": "Mr. Yadram Yadav",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.04708531,
                28.5137604
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T02:36:26.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 176714,
            "time": "07:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 477270,
            "houseCoordinates": {
                "lat": 28.512295558626946,
                "long": 77.03959189298607
            }
        }
    },
    {
        "cookId": 50463,
        "cookName": "Mr. Vipin  Kumar",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                76.9402195,
                28.3959583
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:06.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                76.9402195,
                28.3959583
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:05:06.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": null
    },
    {
        "cookId": 75813,
        "cookName": "Mr. Dinesh  ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.04202935,
                28.42309994
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:56:23.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 178365,
            "time": "02:00 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T08:36:03.000Z",
            "houseId": 476676,
            "houseCoordinates": {
                "lat": 28.42330364869215,
                "long": 77.04196840665186
            }
        },
        "nextVisit": {
            "id": 178662,
            "time": "05:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 480792,
            "houseCoordinates": {
                "lat": 28.4282702,
                "long": 77.0381737
            }
        }
    },
    {
        "cookId": 87293,
        "cookName": "Mr. Raj  Kumar",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0930518,
                28.4813704
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:36:52.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": null
    },
    {
        "cookId": 19948,
        "cookName": "Mr. Kamlesh Mandal",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.093799,
                28.4028896
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:43:29.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 175715,
            "time": "04:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 453984,
            "houseCoordinates": {
                "lat": 28.390829712084525,
                "long": 77.08969245121206
            }
        }
    },
    {
        "cookId": 80178,
        "cookName": "Mrs. Jostina  Bara",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                76.9818626,
                28.3879724
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:03:19.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                76.9796618,
                28.3883395
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:19.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178240,
            "time": "06:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 482361,
            "houseCoordinates": {
                "lat": 28.40246863168044,
                "long": 76.91691295817819
            }
        }
    },
    {
        "cookId": 67721,
        "cookName": "Mr. Shani  Dev ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0177185,
                28.4604196
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:02:28.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0177509,
                28.4604363
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:29.000Z",
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 163099,
            "time": "01:00 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T07:29:17.000Z",
            "houseId": 428355,
            "houseCoordinates": {
                "lat": 1,
                "long": 1
            }
        },
        "nextVisit": {
            "id": 178822,
            "time": "03:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 482492,
            "houseCoordinates": {
                "lat": 28.392180734082512,
                "long": 76.99400460392566
            }
        }
    },
    {
        "cookId": 57444,
        "cookName": "Mrs. Anjali Bhadauriya",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0025586,
                28.4864535
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:49:36.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178179,
            "time": "03:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 476153,
            "houseCoordinates": {
                "lat": 28.497925,
                "long": 76.982668
            }
        }
    },
    {
        "cookId": 53822,
        "cookName": "Mrs. Amita       ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.03694924999999,
                28.51807553333333
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T05:16:44.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": null
    },
    {
        "cookId": 89360,
        "cookName": "Mr. Wanshlal     ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0138217,
                28.472045
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:04:44.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.018315,
                28.4736333
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:02:50.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 169195,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 477529,
            "houseCoordinates": {
                "lat": 28.4727355,
                "long": 77.04502129999996
            }
        }
    },
    {
        "cookId": 452,
        "cookName": "Mr. Lal Yadav",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0706846,
                28.4222733
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:03:44.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0706869,
                28.4222736
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:00:41.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 179053,
            "time": "03:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 106865,
            "houseCoordinates": {
                "lat": 28.43791478287456,
                "long": 77.11268858984113
            }
        }
    },
    {
        "cookId": 80107,
        "cookName": "Mr. Dipesh Kumar Yadav",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0548874,
                28.4134319
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:57:33.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": null
    },
    {
        "cookId": 88990,
        "cookName": "Mr. Ravindra  Nath",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.05178197,
                28.42252966
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:00:42.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.05178197,
                28.42252966
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:00:42.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 179007,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 481091,
            "houseCoordinates": {
                "lat": 28.42859199999999,
                "long": 77.04944700000001
            }
        }
    },
    {
        "cookId": 86229,
        "cookName": "Mr. Rameshwar  Mandal",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                76.9737931,
                28.4563001
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:15.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                76.9737785,
                28.456275
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:00:55.000Z",
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 178019,
            "time": "02:30 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T09:01:12.000Z",
            "houseId": 65956,
            "houseCoordinates": {
                "lat": 28.456054687500004,
                "long": 76.97373589547777
            }
        },
        "nextVisit": {
            "id": 178985,
            "time": "06:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 480851,
            "houseCoordinates": {
                "lat": 28.45471132430316,
                "long": 76.99830496679387
            }
        }
    },
    {
        "cookId": 87573,
        "cookName": "Mrs. Gudiya Devi",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                76.9661516,
                28.3866544
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:35.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                76.9650372,
                28.3873594
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:03:03.000Z",
        "isCookMoving": true,
        "ongoingVisit": {
            "id": 178921,
            "time": "01:00 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T07:59:09.000Z",
            "houseId": 443697,
            "houseCoordinates": {
                "lat": 28.387066341311648,
                "long": 76.96645837433014
            }
        },
        "nextVisit": {
            "id": 166507,
            "time": "03:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 455380,
            "houseCoordinates": {
                "lat": 28.409351683893703,
                "long": 76.95337255230315
            }
        }
    },
    {
        "cookId": 89740,
        "cookName": "Mrs. Beejita  Rana",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.072366,
                28.4219142
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:29.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0723209,
                28.4220407
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:04:41.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 177333,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 477452,
            "houseCoordinates": {
                "lat": 28.4139763,
                "long": 77.0704437
            }
        }
    },
    {
        "cookId": 63742,
        "cookName": "Mr. Ballu   ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.1007404,
                28.4880381
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:02.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.1008269,
                28.4880951
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:02.000Z",
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 178171,
            "time": "02:30 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T08:36:00.000Z",
            "houseId": 451361,
            "houseCoordinates": {
                "lat": 28.45892809999997,
                "long": 77.08776370000005
            }
        },
        "nextVisit": {
            "id": 175921,
            "time": "06:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 42360,
            "houseCoordinates": {
                "lat": 28.45234707745847,
                "long": 77.0992095372487
            }
        }
    },
    {
        "cookId": 5149,
        "cookName": "Mr. Roshan Kumar",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.05049872398376,
                28.402345776557922
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:00:45.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.05049872398376,
                28.402345776557922
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:00:44.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 174899,
            "time": "04:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 65912,
            "houseCoordinates": {
                "lat": 28.389190188227,
                "long": 77.05897383142435
            }
        }
    },
    {
        "cookId": 56520,
        "cookName": "Mr. Parmanand  Raut",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.04208561911508,
                28.37837837837838
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:51:12.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 177471,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 114680,
            "houseCoordinates": {
                "lat": 28.404296249006443,
                "long": 77.06787323579192
            }
        }
    },
    {
        "cookId": 92808,
        "cookName": "Mrs. Priyanka  Yadav",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0945761,
                28.4300863
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:04:46.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0948735,
                28.4301876
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:02:53.000Z",
        "isCookMoving": true,
        "ongoingVisit": {
            "id": 177257,
            "time": "02:30 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T08:47:02.000Z",
            "houseId": 409883,
            "houseCoordinates": {
                "lat": 28.4308713620034,
                "long": 77.09443952450411
            }
        },
        "nextVisit": {
            "id": 172882,
            "time": "05:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 480005,
            "houseCoordinates": {
                "lat": 28.4439447,
                "long": 77.0785315
            }
        }
    },
    {
        "cookId": 38512,
        "cookName": "Mr. Raveen Rambabu Yadav",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                76.9911275,
                28.4186117
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:25.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                76.9903418,
                28.4182144
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:00:41.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178757,
            "time": "07:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 463121,
            "houseCoordinates": {
                "lat": 28.45455034575758,
                "long": 76.97630865499377
            }
        }
    },
    {
        "cookId": 91318,
        "cookName": "Mr. Aman  Prajapati",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0589058,
                28.4761175
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:08:59.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 175991,
            "time": "04:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 447761,
            "houseCoordinates": {
                "lat": 28.458966211958877,
                "long": 77.08905449814162
            }
        }
    },
    {
        "cookId": 49249,
        "cookName": "Mrs. Rajani Chaurasiya",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0811097,
                28.4691605
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:32:28.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 171840,
            "time": "06:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 458715,
            "houseCoordinates": {
                "lat": 28.4637247,
                "long": 77.0582604
            }
        }
    },
    {
        "cookId": 5432,
        "cookName": "Mr. Sagar Prasad",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0978653,
                28.4802584
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:04:44.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0978682,
                28.4802579
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:00:44.000Z",
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 168374,
            "time": "11:00 AM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T05:42:25.000Z",
            "houseId": 21749,
            "houseCoordinates": {
                "lat": 28.47189552885349,
                "long": 77.09962909214552
            }
        },
        "nextVisit": {
            "id": 178308,
            "time": "05:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 434136,
            "houseCoordinates": {
                "lat": 28.47679219999999,
                "long": 77.0767175
            }
        }
    },
    {
        "cookId": 9039,
        "cookName": "Mr. Jagat  Singh",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0386798,
                28.5042945
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:33:56.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 169683,
            "time": "02:00 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T08:33:56.000Z",
            "houseId": 387478,
            "houseCoordinates": {
                "lat": 28.504440307617173,
                "long": 77.03858794644648
            }
        },
        "nextVisit": {
            "id": 174180,
            "time": "04:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 480439,
            "houseCoordinates": {
                "lat": 28.45933228583649,
                "long": 77.0599798384531
            }
        }
    },
    {
        "cookId": 37762,
        "cookName": "Mrs.Pooja        ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0707563,
                28.4180541
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:35.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0699375,
                28.4208291
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:35.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 177385,
            "time": "06:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 473897,
            "houseCoordinates": {
                "lat": 28.4049902,
                "long": 77.0663191
            }
        }
    },
    {
        "cookId": 92563,
        "cookName": "Mrs. Reena Kumari",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0590043,
                28.4662867
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:31.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0588865,
                28.4660505
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:31.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178556,
            "time": "03:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 480969,
            "houseCoordinates": {
                "lat": 28.41407401508589,
                "long": 77.06849282607436
            }
        }
    },
    {
        "cookId": 82836,
        "cookName": "Mrs. Puja Srivastava",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0513574,
                28.4191363
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:03:09.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0513574,
                28.4191363
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:03:09.000Z",
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 176618,
            "time": "01:00 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T07:58:20.000Z",
            "houseId": 480441,
            "houseCoordinates": {
                "lat": 28.41921541900737,
                "long": 77.0515657402575
            }
        },
        "nextVisit": {
            "id": 177898,
            "time": "05:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 482270,
            "houseCoordinates": {
                "lat": 28.41044530000001,
                "long": 77.05455399999998
            }
        }
    },
    {
        "cookId": 81347,
        "cookName": "Mr. Harjeet Singh",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0611647,
                28.4082007
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:04:35.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.062255,
                28.4076792
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:02:24.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 177964,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 475606,
            "houseCoordinates": {
                "lat": 28.4164401,
                "long": 77.0269698
            }
        }
    },
    {
        "cookId": 11356,
        "cookName": "Mr. Kuldeep Singh",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0550338,
                28.4306908
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:41:12.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": null
    },
    {
        "cookId": 88643,
        "cookName": "Mr. Rohit  Kumar",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0446823,
                28.4263228
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:03:01.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0446823,
                28.4263228
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:03:01.000Z",
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 177940,
            "time": "12:00 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T06:31:02.000Z",
            "houseId": 319144,
            "houseCoordinates": {
                "lat": 28.416217742105164,
                "long": 77.08328118547797
            }
        },
        "nextVisit": {
            "id": 169791,
            "time": "04:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 13495,
            "houseCoordinates": {
                "lat": 28.42036437988281,
                "long": 77.07830289131529
            }
        }
    },
    {
        "cookId": 9490,
        "cookName": "Mrs. Priyanka Devi",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.09355594,
                28.45516569
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:36:50.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 175217,
            "time": "05:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 480066,
            "houseCoordinates": {
                "lat": 28.44087759999998,
                "long": 77.10067309999998
            }
        }
    },
    {
        "cookId": 33792,
        "cookName": "Mrs. Renu    Gupta ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0969599,
                28.4867704
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:10.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.09697,
                28.4867783
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:10.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178204,
            "time": "03:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 481934,
            "houseCoordinates": {
                "lat": 28.4490011,
                "long": 77.09573
            }
        }
    },
    {
        "cookId": 91819,
        "cookName": "Mr. Shobha Kant Choudhary ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.07671833333333,
                28.46876333333333
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:04:42.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.07781,
                28.468315
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:42.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 173148,
            "time": "05:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 175157,
            "houseCoordinates": {
                "lat": 28.488251703510645,
                "long": 77.10880240425467
            }
        }
    },
    {
        "cookId": 89023,
        "cookName": "Mr. Yogesh  ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.1456171,
                28.4404154
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:29.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.1455842,
                28.4403828
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:29.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178571,
            "time": "03:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 482283,
            "houseCoordinates": {
                "lat": 28.444336750341357,
                "long": 77.11127473041415
            }
        }
    },
    {
        "cookId": 92096,
        "cookName": "Mrs. Nayani Baske",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.050687,
                28.4024033
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:13.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0508456,
                28.4022994
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:13.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 179006,
            "time": "05:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 192248,
            "houseCoordinates": {
                "lat": 28.3976207,
                "long": 77.0732512
            }
        }
    },
    {
        "cookId": 31457,
        "cookName": "Mr. Reba Dhar",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.059856,
                28.480709
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T06:23:25.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": null
    },
    {
        "cookId": 78636,
        "cookName": "Mr. Aakash Gaur",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.064728,
                28.4489357
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:08.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.064728,
                28.4489357
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:05:08.000Z",
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 178134,
            "time": "02:30 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T09:05:08.000Z",
            "houseId": 461793,
            "houseCoordinates": {
                "lat": 28.448935673725547,
                "long": 77.06460022584936
            }
        },
        "nextVisit": {
            "id": 178809,
            "time": "04:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 435858,
            "houseCoordinates": {
                "lat": 28.428072,
                "long": 77.102222
            }
        }
    },
    {
        "cookId": 2054,
        "cookName": "Mr. Jitu Chauhan",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.09865,
                28.4690768
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:54:37.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 178826,
            "time": "01:00 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T07:40:23.000Z",
            "houseId": 482499,
            "houseCoordinates": {
                "lat": 28.4692067,
                "long": 77.0986665
            }
        },
        "nextVisit": {
            "id": 171453,
            "time": "05:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 479933,
            "houseCoordinates": {
                "lat": 28.46298527419893,
                "long": 77.08855524495549
            }
        }
    },
    {
        "cookId": 79471,
        "cookName": "Mr. Hansh Lal ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0815216,
                28.4661274
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:25:56.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 178981,
            "time": "01:30 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T08:06:12.000Z",
            "houseId": 432527,
            "houseCoordinates": {
                "lat": 28.465508300000003,
                "long": 77.08135589999996
            }
        },
        "nextVisit": {
            "id": 178920,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 482518,
            "houseCoordinates": {
                "lat": 28.4720958242554,
                "long": 77.04542008639079
            }
        }
    },
    {
        "cookId": 94380,
        "cookName": "Mr. Jagannath Kamat",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0490416,
                28.3954847
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:40.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0490416,
                28.3954847
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:08.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178637,
            "time": "03:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 32323,
            "houseCoordinates": {
                "lat": 28.40257066438525,
                "long": 77.08900233730674
            }
        }
    },
    {
        "cookId": 94498,
        "cookName": " Mr. Jitendra Mandal",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0487153,
                28.4258106
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:52:03.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 178720,
            "time": "01:30 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T08:52:03.000Z",
            "houseId": 482463,
            "houseCoordinates": {
                "lat": 28.4233707,
                "long": 77.0463098
            }
        },
        "nextVisit": {
            "id": 177655,
            "time": "05:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 444453,
            "houseCoordinates": {
                "lat": 28.4125871,
                "long": 77.0358727
            }
        }
    },
    {
        "cookId": 80122,
        "cookName": "Mr. Sonu Kumar",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                76.968144,
                28.446464
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:02:04.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                76.968144,
                28.446464
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:02:04.000Z",
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 178761,
            "time": "02:00 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T08:23:52.000Z",
            "houseId": 29553,
            "houseCoordinates": {
                "lat": 28.4464275,
                "long": 76.968179
            }
        },
        "nextVisit": {
            "id": 178531,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 478290,
            "houseCoordinates": {
                "lat": 28.41352495621214,
                "long": 77.04508879669349
            }
        }
    },
    {
        "cookId": 80226,
        "cookName": "Mr. Mukesh  Paswan",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0340047,
                28.4191707
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:01.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0339996,
                28.4192239
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:00.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178187,
            "time": "04:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 215053,
            "houseCoordinates": {
                "lat": 28.406143188476545,
                "long": 77.04021918601295
            }
        }
    },
    {
        "cookId": 94153,
        "cookName": "Mr. Vijay Kumar Paswan",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0501499,
                28.4415213
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T06:39:24.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 172535,
            "time": "05:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 374101,
            "houseCoordinates": {
                "lat": 28.4160756,
                "long": 77.0677017
            }
        }
    },
    {
        "cookId": 93020,
        "cookName": "Mr. Harendra Yadav",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0342734,
                28.4041531
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:36:20.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178203,
            "time": "05:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 305636,
            "houseCoordinates": {
                "lat": 28.381575547606783,
                "long": 77.06176182255149
            }
        }
    },
    {
        "cookId": 79336,
        "cookName": "Mr. Santosh Kumar Sahani",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0934385,
                28.4735433
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:56:09.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": null
    },
    {
        "cookId": 74635,
        "cookName": "Mrs. Radhika    ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.013189,
                28.4874115
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:04:51.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0131815,
                28.4874098
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:00:51.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 177784,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 476930,
            "houseCoordinates": {
                "lat": 28.5330989,
                "long": 77.018098
            }
        }
    },
    {
        "cookId": 88904,
        "cookName": "Mrs.Dolly     ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.1050978,
                28.4328677
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:25:42.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 174911,
            "time": "05:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 481452,
            "houseCoordinates": {
                "lat": 28.436937224151237,
                "long": 77.10698478736148
            }
        }
    },
    {
        "cookId": 91718,
        "cookName": "Mr. Jitendra Kumar  Pal",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0912936,
                28.4728173
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:04:51.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0913082,
                28.4727962
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:00:56.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178020,
            "time": "05:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 477194,
            "houseCoordinates": {
                "lat": 28.49076137436999,
                "long": 77.09119806066155
            }
        }
    },
    {
        "cookId": 78967,
        "cookName": "Mr. Sajal Mondal",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0507867,
                28.4251087
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T07:29:52.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 178355,
            "time": "11:30 AM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T07:29:52.000Z",
            "houseId": 436572,
            "houseCoordinates": {
                "lat": 28.42499916295494,
                "long": 77.05072004512961
            }
        },
        "nextVisit": {
            "id": 177815,
            "time": "04:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 481438,
            "houseCoordinates": {
                "lat": 28.4614026,
                "long": 77.0662612
            }
        }
    },
    {
        "cookId": 93601,
        "cookName": "Mr. Devendra Tiwari",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0886236,
                28.3812766
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:40.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0886735,
                28.3813836
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:00:40.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 175439,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 481594,
            "houseCoordinates": {
                "lat": 28.412951097176027,
                "long": 77.11234090849757
            }
        }
    },
    {
        "cookId": 85000,
        "cookName": "Mr. Gajendra Singh Dhami",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                76.9522649,
                28.3897912
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:12.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                76.9521956,
                28.3898599
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:11.000Z",
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 179011,
            "time": "01:30 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T08:16:09.000Z",
            "houseId": 482244,
            "houseCoordinates": {
                "lat": 28.390279242036264,
                "long": 76.95216736436555
            }
        },
        "nextVisit": {
            "id": 178807,
            "time": "03:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 482248,
            "houseCoordinates": {
                "lat": 28.387984978076062,
                "long": 76.97946356514623
            }
        }
    },
    {
        "cookId": 7704,
        "cookName": "Mamata Bag",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0513079,
                28.4096889
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:03:25.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0511719,
                28.412161
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:25.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 174685,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 479890,
            "houseCoordinates": {
                "lat": 28.399143299999977,
                "long": 77.06036689999995
            }
        }
    },
    {
        "cookId": 14506,
        "cookName": "Mr. Kailash Ram",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0782099,
                28.451051
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:04:55.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0730018,
                28.459089
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:00:54.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178333,
            "time": "05:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 12165,
            "houseCoordinates": {
                "lat": 28.45338002594912,
                "long": 77.09141948813298
            }
        }
    },
    {
        "cookId": 94287,
        "cookName": "Mrs. Sapna   ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0002904,
                28.4674979
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:04:54.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0004644,
                28.4675025
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:18.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178913,
            "time": "06:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 472919,
            "houseCoordinates": {
                "lat": 28.46905346465485,
                "long": 77.00006055706376
            }
        }
    },
    {
        "cookId": 86977,
        "cookName": "Ms. Dhanvanti Joshi",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.1005749,
                28.489527
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:04:59.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.1005228,
                28.4889668
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:00.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 175759,
            "time": "04:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 481498,
            "houseCoordinates": {
                "lat": 28.45836375304438,
                "long": 77.09906883232306
            }
        }
    },
    {
        "cookId": 80009,
        "cookName": "Mr. Bamdev Bhatt",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0384089,
                28.4276837
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:09:09.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 177182,
            "time": "12:00 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T07:22:07.000Z",
            "houseId": 481611,
            "houseCoordinates": {
                "lat": 28.4281746,
                "long": 77.0384988
            }
        },
        "nextVisit": {
            "id": 178353,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 431582,
            "houseCoordinates": {
                "lat": 28.44156938143347,
                "long": 77.08503953128117
            }
        }
    },
    {
        "cookId": 85724,
        "cookName": "Mr. Prince  Kumar ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0696833,
                28.3699233
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:14.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.069535,
                28.3691117
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:45.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178898,
            "time": "05:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 447046,
            "houseCoordinates": {
                "lat": 28.3915373,
                "long": 77.0651871
            }
        }
    },
    {
        "cookId": 88632,
        "cookName": "Mrs. Mamta  Kashyap ",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.093953,
                28.4894276
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:04:01.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0939236,
                28.4894532
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:03.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": null
    },
    {
        "cookId": 86908,
        "cookName": "Mr. Ashok Poddar",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.031823,
                28.5033232
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:07.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0342117,
                28.5035983
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:07.000Z",
        "isCookMoving": true,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178242,
            "time": "05:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 472596,
            "houseCoordinates": {
                "lat": 28.50765,
                "long": 77.029596
            }
        }
    },
    {
        "cookId": 91094,
        "cookName": "Mr. Mohan  Ram",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0724885,
                28.4776732
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:03:22.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.07257,
                28.4776444
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:01:21.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": {
            "id": 178896,
            "time": "07:30 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 474464,
            "houseCoordinates": {
                "lat": 28.492241573789634,
                "long": 77.08758877785749
            }
        }
    },
    {
        "cookId": 91936,
        "cookName": "Mrs. Pooja  Rani",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0435485,
                28.3976728
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T09:05:34.000Z",
        "previousLocation": {
            "type": "Point",
            "coordinates": [
                77.0435485,
                28.3976728
            ]
        },
        "previousLocationCreatedAt": "2026-04-15T09:05:34.000Z",
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": null
    },
    {
        "cookId": 90410,
        "cookName": "Mrs. Mala   Kumari",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                76.9883314,
                28.4504219
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:38:15.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": null
    },
    {
        "cookId": 93018,
        "cookName": "Mr. Manoj Chand",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0675014,
                28.5062387
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T07:51:20.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": {
            "id": 178922,
            "time": "01:30 PM",
            "status": "ONGOING",
            "checkInTime": "2026-04-15T07:51:20.000Z",
            "houseId": 482044,
            "houseCoordinates": {
                "lat": 28.504873,
                "long": 77.06760369999999
            }
        },
        "nextVisit": {
            "id": 178401,
            "time": "04:00 PM",
            "status": "COOK_CONFIRMED",
            "houseId": 480385,
            "houseCoordinates": {
                "lat": 28.50706099559589,
                "long": 77.05457608649452
            }
        }
    },
    {
        "cookId": 90167,
        "cookName": "Mrs. Pihu Rani",
        "currentLocation": {
            "type": "Point",
            "coordinates": [
                77.0700625,
                28.4451648
            ]
        },
        "currentLocationCreatedAt": "2026-04-15T08:54:36.000Z",
        "previousLocation": null,
        "previousLocationCreatedAt": null,
        "isCookMoving": false,
        "ongoingVisit": null,
        "nextVisit": null
    }
];

export const USE_DUMMY_DATA = false;
